import React, {Component} from 'react';
import BodyConditionGroup from './BodyConditionGroup';
import {getScreenshot} from './../../../helpers/ScreenshotHelper';

class BodyCondition extends Component {

   render() {
    const {heading, groups} = this.props.data;
    const {output} = this.props;

    return (
      <div className=" nppe2-fc-feeding-guidelines-body-condition" id="fc-screenshot-feeding-guidelines-body-condition">
        <div className="row">
          <div className="col-xs-12 nppe2-fc-sub-title-output">
            {heading}
          </div>

          <div className="col-xs-12">
            {groups.map((group, index) => (
              <BodyConditionGroup
                key={index}
                data={group}
                output={output}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default BodyCondition;
